import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useQuery } from '@tanstack/react-query';
import { Order } from '@/types/models/Order';

type Filters =
  | {
      reservation_id?: number | null;
    }
  | undefined;
const useOrders = (enabled: boolean = true, filters: Filters = undefined) => {
  const client = supabaseClient;
  const queryKey = ['orders', filters?.reservation_id];

  const queryFn = async () => {
    return getOrders(client, filters);
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled,
    staleTime: 1000 * 60 * 5,
  });
};

export default useOrders;

function getOrders(client: SupabaseClient, filters: Filters): Order[] {
  let clientWithFilters = client
    .from('orders')
    .select(
      `
        id,
        reservation_id,
        order,
        created_at
      `
    )
    .order('created_at', { ascending: true });

  if (filters?.reservation_id) {
    clientWithFilters = clientWithFilters.eq('reservation_id', filters.reservation_id);
  }

  return clientWithFilters.then((result: any) => result.data) as unknown as Order[];
}
